<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.editDistrbutionPoint") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" v-if="!loading">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 class="mt-5 font-weight-bold">
            {{ $t("PLACEHOLDERS.distrbution_point_data") }}
          </h5>
          
          <!-- Start:: Distribution Point Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.distrbution_point_name')"
            v-model.trim="data.name"
            required
          />
          <!-- End:: Distribution Point Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="distrbution_point_image"
            :preSelectedImage="data.image.url"
            :placeholder="$t('PLACEHOLDERS.user_image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Username Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.new_username')"
            v-model.trim="data.distrbution_point_name"
          />
          <!-- End:: Username Input -->

          <!-- Start:: Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
            v-model.trim="data.commercial_registration_number"
            required
          />
          <!-- End:: Commercial Registration Number -->

          <!-- Start:: New Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.new_password')"
            v-model.trim="data.password"
          />
          <!-- End:: New Password Input -->

          <!-- Start:: Confirm New Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
          />
          <!-- End:: Confirm New Password Input -->

          <!-- Start:: Account Status Switch -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Account Status Switch -->

          <!-- Start:: Location Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">
            {{ $t("PLACEHOLDERS.location_on_map") }}
          </h5>
          
          <!-- Start:: Google Map -->
          <div class="col-12 mb-4">
            <ChangableMapComponent
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
            />
          </div>
          <!-- End:: Google Map -->
          <!-- End:: Location Details -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>

    <!-- Start:: Loading State -->
    <div v-else class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <!-- End:: Loading State -->
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChangableMapComponent from "@/components/general/ChangableMapComponent.vue";

export default {
  name: "EditDistrbutionPoint",

  components: {
    ChangableMapComponent,
  },

  data() {
    return {
      loading: false,
      isWaitingRequest: false,
      data: {
        image: {
          path: null,
          file: null,
          storagePath: null,
          url: null,
        },
        name: null,
        distrbution_point_name: null,
        mobile: null,
        password: null,
        passwordConfirmation: null,
        active: true,
        commercial_registration_number: null,
        lat: 24.7136,
        lng: 46.6753,
      },
    };
  },

  computed: {
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
  },

  methods: {
    // Handle image selection for personal image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Handle location selection from map
    selectLocation(location) {
      this.data.lat = location.lat;
      this.data.lng = location.lng;
    },

    // Fetch distribution point data
    async getDistrbutionPointData() {
      this.loading = true;
      try {
        const res = await this.$axios.get(
          `distrbution-points/${this.$route.params.id}`
        );
        const point = res.data.data;

        // Populate form with existing data
        this.data.name = point.name;
        this.data.distrbution_point_name = point.distrbution_point_name;
        this.data.mobile = point.mobile;
        this.data.active = point.is_active;
        this.data.commercial_registration_number = point.commercial_registration_number;
        this.data.lat = point.lat || 24.7136;
        this.data.lng = point.lng || 46.6753;

        // Set image
        if (point.avatar) {
          this.data.image = {
            path: point.avatar.path,
            file: null,
            storagePath: point.avatar.path,
            url: point.avatar.url,
          };
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message.error(error.response?.data?.message || this.$t("MESSAGES.error"));
        this.$router.push("/DistrbutionPoints/all");
      }
    },

    // Validate form inputs before submission
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    // Submit form data
    async submitForm() {
      const formData = new FormData();

      // Append required fields
      formData.append("name", this.data.name);
      formData.append("mobile", this.data.mobile);
      formData.append("commercial_registration_number", this.data.commercial_registration_number);
      formData.append("lat", this.data.lat);
      formData.append("lng", this.data.lng);
      // formData.append("is_active", this.data.active ? 1 : 0);

      // Append username only if changed
      if (this.data.distrbution_point_name) {
        formData.append("distrbution_point_name", this.data.distrbution_point_name);
      }

      // Append avatar only if changed
      if (this.data.image.storagePath) {
        formData.append("avatar", this.data.image.storagePath);
      }

      // Append password only if provided
      if (this.data.password) {
        formData.append("password", this.data.password);
        formData.append("password_confirmation", this.data.passwordConfirmation);
      }

      // Add PUT method override
      formData.append("_method", "PUT");

      try {
        await this.$axios.post(
          `distrbution-points/${this.$route.params.id}`,
          formData
        );
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push("/DistrbutionPoints/all");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message || this.$t("MESSAGES.error"));
      }
    },
  },

  created() {
    // Fetch distribution point data on component creation
    this.getDistrbutionPointData();
  },
};
</script>
